import { FC } from 'react';
import { DefaultChip } from 'shared/DefaultChip';

export const BetaTag: FC = () => {
  return <DefaultChip label="Beta" color="warning" variant="outlined" />;
};
